export default __webpack_public_path__ + "images/6O.269e056.png";